/**
 * @copyright       Palace Resorts
 * @description     Mensajes para el formulario de registro de un proveedor outsourcing
 * @author          
 * @creationDate    
 */
 export default {
    fallbackLocale: 'ESP',
    locale: 'ESP',
    messages: {
        'ESP': {
            lblGeneralData: "Datos Generales",
            lblSTPSRegister: "Registro STPS",
            lblEmployerRegister: "Registro Patronal",
            lblOutsourcingActivities: "Actividades de subcontratación",
            lblDocuments: "Documentos",
            lblDocument: "Documento",
            lblID: "ID"
            
        },
        'ENG': {
            lblGeneralData: "General Data",
            lblSTPSRegister: "STPS Register",
            lblEmployerRegister: "Employer Register",
            lblOutsourcingActivities: "Outsourcing Activities",
            lblDocuments: "Documents",
            lblDocument: "Document",
            lblID: "ID"    
        }
    } //end Messages
}